import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const EnaSettings: IModel = {
  title: 'Ena Settings',
  apiPath: 'system/ena_settings',
  forms: {
    insert: {
      fields: [{ source: 'tenant_id', readonly: false }, 'koef_korisna_pov', 'zapisnici_folder', 'geodata_izvjestaj_enabled', 'geodata_izvjestaj_email', 'hide_zapisnik_if_no_filename'],
    },
    update: {
      fields: [{ source: 'tenant_id', readonly: false }, 'koef_korisna_pov', 'zapisnici_folder', 'geodata_izvjestaj_enabled', 'geodata_izvjestaj_email', 'hide_zapisnik_if_no_filename'],
    },
    search: {
      fields: ['tenant_id', 'koef_korisna_pov', 'zapisnici_folder', 'geodata_izvjestaj_enabled', 'geodata_izvjestaj_email', 'hide_zapisnik_if_no_filename'],
    },
  },
  listViews: {
    default: {
      fields: ['id', 'tenant_id', 'koef_korisna_pov', 'zapisnici_folder', 'geodata_izvjestaj_enabled', 'geodata_izvjestaj_email', 'hide_zapisnik_if_no_filename'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'tenant_id',
      source: 'tenant_id',
      ttoken: 'admin:common.tenant_id',
      type: 'picker',
      subModel: {
        apiPath: 'system/tenants?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      readonly: true,
      validation: {
        required: true,
      },
      filter: true
    },
    {
      title: 'koef_korisna_pov',
      source: 'koef_korisna_pov',
      ttoken: 'admin:ena.koef_korisna_pov',
      type: 'numeric',
      filter: true,
      validation: {
        required: true
      }
    },
    {
      title: 'zapisnici_folder',
      source: 'zapisnici_folder',
      ttoken: 'admin:ena.zapisnici_folder',
      type: 'text',
      filter: true,
      validation: {
        required: true,
        maxLength: 100
      }
    },
    {
      title: 'geodata_izvjestaj_enabled',
      source: 'geodata_izvjestaj_enabled',
      ttoken: 'admin:ena.geodata_izvjestaj_enabled',
      type: 'boolean',
      items: {
        labels: ['common.ne', 'common.da'],
        values: [false, true],
        default: false,
      },
      filter: true,
    },
    {
      title: 'geodata_izvjestaj_email',
      source: 'geodata_izvjestaj_email',
      ttoken: 'admin:ena.geodata_izvjestaj_email',
      type: 'mail',
      placeholder: 'devteam@prehnit.hr',
      filter: true,
      validation: {
        required: true,
        maxLength: 255,
        regex: 'email',
      }
    },
    {
      title: 'hide_zapisnik_if_no_filename',
      source: 'hide_zapisnik_if_no_filename',
      ttoken: 'admin:ena.hide_zapisnik_if_no_filename',
      type: 'boolean',
      items: {
        labels: ['common.ne', 'common.da'],
        values: [false, true],
        default: false,
      },
      filter: true,
    }
  ],
};

export default EnaSettings;
